// extracted by mini-css-extract-plugin
export default {"payout":"CurrentPayout_payout__l7Ink","label":"CurrentPayout_label__brWlH","value":"CurrentPayout_value__c8ncK"};